// AuthenticationProvider.js
const serverUrl = "/api";
class AuthenticationProvider {
    
    async checkCredentials(username, pw) {
        try {
            console.log("checkCredentials2");
            const response = await fetch(serverUrl + '/checkCredentials', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: username,
                    password: pw,
                }),
            });
            console.log("response");
            console.log(response);

            if (response.ok) {
                console.log('Match: ', response.statusText);
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }

    async checkAuthCredentials(username, pw) {
        try {
            console.log("checkCredentials2");
            const response = await fetch(serverUrl + '/checkAuthCredentials', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: username,
                    password: pw,
                }),
            });
            console.log("response");
            console.log(response);

            if (response.ok) {
                console.log('Match: ', response.statusText);
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }

    async loginFB(token, userId, referral) {
        try {
            console.log("auth provider loginFB");
            const response = await fetch(serverUrl + '/auth/loginFB', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    accessToken: token,
                    userID : userId,
                    referral: referral
                }),
            });
            console.log("response");
            console.log(response);

            if (response.ok) {
                console.log('Match: ', response.statusText);
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }

    async loginGoogle(tokenId, googleId, referral) {
        try {
            console.log("auth provider loginGoogle");
            const response = await fetch(serverUrl + '/auth/loginGoogle', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    tokenId: tokenId,
                    googleId: googleId,
                    referral: referral
                }),
            });
            console.log("response");
            console.log(response);

            if (response.ok) {
                console.log('Match: ', response.statusText);
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }

    async registerUser(username, pw, email, salt, referral) {
        try {
            console.log("registerUser");
            const response = await fetch(serverUrl + '/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: username,
                    password: pw,
                    email: email,
                    salt: salt,
                    referral: referral,
                }),
            });
            console.log(response);
            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return response.status;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }

    async deleteUser(token) {
        try {
            console.log("DeleteUser");
            const response = await fetch(serverUrl + '/user', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: token
                }),
            });
            console.log(response);
            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                console.error('Server error:', response.statusText);
                return response.status;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }
    async requestPasswordReset(email) {
        try {
            const response = await fetch(serverUrl + '/request-password-reset', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            if (response.ok) return await response.json();
            return { error: response.statusText };
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }

    async resetPassword(email, code, newPassword) {
        try {
            const response = await fetch(serverUrl + '/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, code, newPassword }),
            });
            if (response.ok) return await response.json();
            return { error: response.statusText };
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    }
}

export default AuthenticationProvider;
